<table *ngIf="historyEvents.length > 0" class="table table-hover table-striped">
  <thead>
    <tr>
      <th class="history-element-timestamp">
        <small>{{ 'booking.default.summary.history-events.titles.timestamp' | translate }}</small>
      </th>
      <th>
        <small>{{ 'booking.default.summary.history-events.titles.historyKey' | translate }}</small>
      </th>
      <th aria-label="row actions">&nbsp;</th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let element of historyEvents">
      <tr
        class="history-element-row"
        [class.history-expanded-row]="expandedElement === element"
        (click)="expandedElement = expandedElement === element ? null : element"
      >
        <td class="history-element-timestamp">
          <time [dateTime]="element.timestamp">
            <small>
              {{ element.timestamp | localizedDate: 'mediumDate' }},
              <br />
              {{ element.timestamp | localizedDate: 'mediumTime' }}
            </small>
          </time>
        </td>
        <td>
          <small>{{ 'booking.default.summary.history-events.event-type.' + element.historyKey | translate }}</small>
        </td>
        <td class="history-element-expand">
          <button
            type="button"
            class="btn border-0"
            (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()"
            aria-label="expand row"
          >
            <i *ngIf="expandedElement !== element" class="bi bi-chevron-down"
              [attr.aria-label]="'booking.default.summary.history-events.controls.expand-event' | translate"></i>
            <i *ngIf="expandedElement === element" class="bi bi-chevron-up"
              [attr.aria-label]="'booking.default.summary.history-events.controls.fold-event' | translate"></i>
          </button>
        </td>
      </tr>

      <!-- Expanded Detail Row -->
      <tr
        class="history-detail-row"
        [@detailExpand]
        *ngIf="expandedElement === element"
      >
        <td [attr.colspan]="3">
          <div class="history-element-detail">
            <dl>
              <dt>{{ 'booking.default.summary.history-events.details.timestamp' | translate }}</dt>
              <dd><time [dateTime]="element.timestamp">
                {{ element.timestamp | localizedDate: 'full' }}
              </time></dd>

              <ng-container *ngIf="element.priorPaymentStatus">
                <dt>{{ 'booking.default.summary.history-events.details.prior-payment-status' | translate }}</dt>
                <dd>{{ 'booking.default.status.' + element.priorPaymentStatus.toLowerCase() | translate }}</dd>
              </ng-container>

              <ng-container *ngIf="element.newPaymentStatus">
                <dt>{{ 'booking.default.summary.history-events.details.new-payment-status' | translate }}</dt>
                <dd>{{ 'booking.default.status.' + element.newPaymentStatus.toLowerCase() | translate }}</dd>
              </ng-container>

              <ng-container *ngIf="element.selectedPaymentMethod">
                <dt>{{ 'booking.default.summary.history-events.details.selected-payment-method.label' | translate }}</dt>
                <dd>{{ 'booking.default.summary.history-events.details.selected-payment-method.' + element.selectedPaymentMethod.toLowerCase() | translate }}</dd>
              </ng-container>

              <ng-container *ngIf="element.refundedAmount">
                <dt>{{ 'booking.default.summary.history-events.details.refunded-amount' | translate }}</dt>
                <dd>{{ element.refundedAmount.amount | currency:element.refundedAmount.currency:undefined:undefined:currentLanguage }}</dd>
              </ng-container>

              <ng-container *ngIf="element.comment">
                <dt>{{ 'booking.default.summary.history-events.details.comment' | translate }}</dt>
                <dd class="comment-display">{{ element.comment }}</dd>
              </ng-container>

              <ng-container *ngIf="element.fileName">
                <dt>{{ 'booking.default.summary.history-events.details.filename' | translate }}</dt>
                <dd>{{ element.fileName }}</dd>
              </ng-container>

              <ng-container *ngIf="element.oldEvent">
                <dt>{{ 'booking.default.summary.history-events.details.old-event' | translate }}</dt>
                <dd>
                  <ng-container *ngIf="!element.oldEvent.delete">
                    {{ 'booking.default.summary.history-events.details.event-format.full' | translate: {
                      id: element.oldEvent.id,
                      date: element.oldEvent.time | localizedDate: 'mediumDate',
                      time: element.oldEvent.time | localizedDate: 'shortTime',
                      testcenterName: element.oldEvent.testcenterName,
                      testarea: element.oldEvent.testarea
                    } }}
                  </ng-container>
                  <ng-container *ngIf="element.oldEvent.delete">
                    {{ 'booking.default.summary.history-events.details.event-format.minimal' | translate: {
                      id: element.oldEvent.id
                    } }}
                  </ng-container>
                </dd>
              </ng-container>

              <ng-container *ngIf="element.newEvent">
                <dt>{{ 'booking.default.summary.history-events.details.new-event' | translate }}</dt>
                <dd>
                  <ng-container *ngIf="!element.newEvent.delete">
                    {{ 'booking.default.summary.history-events.details.event-format.full' | translate: {
                      id: element.newEvent.id,
                      date: element.newEvent.time | localizedDate: 'mediumDate',
                      time: element.newEvent.time | localizedDate: 'shortTime',
                      testcenterName: element.newEvent.testcenterName,
                      testarea: element.newEvent.testarea
                    } }}
                  </ng-container>
                  <ng-container *ngIf="element.newEvent.delete">
                    {{ 'booking.default.summary.history-events.details.event-format.minimal' | translate: {
                      id: element.newEvent.id
                    } }}
                  </ng-container>
                </dd>
              </ng-container>

              <ng-container *ngIf="element.modifyingUser">
                <dt>{{ 'booking.default.summary.history-events.details.modifying-user' | translate }}</dt>
                <dd>
                  <ng-container *ngIf="!element.modifyingUser.delete">
                    {{ 'booking.default.summary.history-events.details.user-format.full' | translate: {
                      id: element.modifyingUser.id,
                      firstname: element.modifyingUser.firstname,
                      lastname: element.modifyingUser.lastname,
                      username: element.modifyingUser.username
                    } }}
                  </ng-container>
                  <ng-container *ngIf="element.modifyingUser.delete">
                    {{ 'booking.default.summary.history-events.details.user-format.minimal' | translate: {
                      id: element.modifyingUser.id
                    } }}
                  </ng-container>
                </dd>
              </ng-container>
            </dl>
          </div>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
